<template>
  <div class="tabsInformes">
    <div class="tabsInformes--bg"></div>
    <ul class="tabsInformes--nav">
      <li
      :class="{active : currentTab === index}"
      class="tabsInformes--navItem"
      v-for="(tab, index) in tabs"
      :key="index"
      @click="currentTab = index">
        {{ tab.titleResume }}
      </li>
    </ul>
    <ul class="tabsInformes--contents">
      <li
      class="tabsInformes--contentsItem"
      v-for="(content, index) in tabs"
      :key="index"
      v-show="currentTab === index">
          <ArticleMain
          :titleResume='content.titleResume'
          :title='content.title'
          :text='content.text'
          :linkPT='content.linkPT'
          :linkES='content.linkES'
          :linkIN='content.linkIN'
          :imgFull='content.imgFull'
          :imgLarge='content.imgLarge'
          :imgMedium='content.imgMedium'
          :imgSmall='content.imgSmall'/>
      </li>
    </ul>
  </div>
</template>

<script>
import { apis } from '@/api.js'
import ArticleMain from '@/components/_ArticleMain'

export default {
  name: 'TableInformes2',
  components: {
    ArticleMain
  },
  data () {
    return {
      url: apis.api.informes2API,
      tabs: '',
      currentTab: 0
    }
  },
  methods: {
    getApi () {
      fetch(this.url)
        .then(response => response.json())
        .then(response => {
          this.tabs = response
        })
    }
  },
  created () {
    this.getApi()
  }
}
</script>

<style lang="sass">
.TabsMain--navItem
  cursor: pointer
</style>
